import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BrandLogoEntityRaw } from "../../interface";
import { brandLogoEntityRaw } from "../../schema";
import { BaseEntity } from "../base.entity";

export class BrandLogoEntity extends BaseEntity<BrandLogoEntityRaw> {
  private static validation = JsonSchemaValidator.compile(brandLogoEntityRaw);

  constructor(value: BrandLogoEntityRaw) {
    super(JsonSchemaValidator.assert(BrandLogoEntity.validation, value));
  }
}
